import { useEffect, useState, useRef } from 'react';

const useAudio = (url: string) => {
    const [audio] = useState(new Audio(url));
    const [playing, setPlaying] = useState(false);
    const [muted, setMuted] = useState(false);
    const isMountedRef = useRef(true);
  
    const toggle = () => setPlaying(!playing);
    
    const play = () => setPlaying(true);
    
    const stop = () => {
        audio.pause();
        audio.currentTime = 0;
        setPlaying(false);
    };
    
    const pause = () => {
        audio.pause();
        setPlaying(false);
    };
    
    const mute = () => {
        audio.muted = true;
        setMuted(true);
    };
    
    const unmute = () => {
        audio.muted = false;
        setMuted(false);
    };
    
    const toggleMute = () => {
        if (muted) {
            unmute();
        } else {
            mute();
        }
    };
  
    useEffect(() => {
        audio.loop = true;
        if (playing && isMountedRef.current) {
            audio.play().catch(err => {
                console.warn('Audio play failed:', err);
            });
        } else {
            audio.pause();
        }
    }, [playing, audio]);
    
    useEffect(() => {
        audio.muted = muted;
    }, [muted, audio]);
  
    useEffect(() => {
        const handleEnded = () => {
            if (isMountedRef.current) {
                setPlaying(false);
            }
        };
        
        audio.addEventListener('ended', handleEnded);
        
        return () => {
            isMountedRef.current = false;
            audio.removeEventListener('ended', handleEnded);
            audio.pause();
            audio.currentTime = 0;
        };
    }, [audio]);
  
    return { 
        playing, 
        muted,
        toggle,
        play,
        stop,
        pause,
        mute,
        unmute,
        toggleMute
    };
};

export default useAudio;